import { render, staticRenderFns } from "./benchmarking-type-ahead.vue?vue&type=template&id=caf70f72&scoped=true"
import script from "./benchmarking-type-ahead.vue?vue&type=script&lang=ts"
export * from "./benchmarking-type-ahead.vue?vue&type=script&lang=ts"
import style0 from "./benchmarking-type-ahead.vue?vue&type=style&index=0&id=caf70f72&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf70f72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caf70f72')) {
      api.createRecord('caf70f72', component.options)
    } else {
      api.reload('caf70f72', component.options)
    }
    module.hot.accept("./benchmarking-type-ahead.vue?vue&type=template&id=caf70f72&scoped=true", function () {
      api.rerender('caf70f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/benchmarking-type-ahead/benchmarking-type-ahead.vue"
export default component.exports